import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'vectronic-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
  imports: [MatIconModule, CommonModule],
})
export class CustomSnackbarComponent {
  snackBarRef = inject<MatSnackBarRef<CustomSnackbarComponent>>(MatSnackBarRef);
  data = inject<{
    icon: string;
    message: string;
    color: string;
  }>(MAT_SNACK_BAR_DATA);

  dismiss() {
    if (window?.getSelection()?.toString()) return;
    this.snackBarRef.dismiss();
  }
}
